import React, { useEffect, useState } from 'react'
import { useForm, SubmitHandler } from 'react-hook-form'
import {
  ModalBody,
  ModalFooterInForm,
  ModalHeader,
  ModalWrapper,
} from '~/components/common/Modal'
import { FormattedMessage } from '~/translations/utils'
import classNames from 'classnames'
import { post } from '~/utils/api'
import TicketForm from './addTicket/TicketForm'
import SelectClient from './addTicket/SelectClient'
import NewClient from './addTicket/NewClient'
import Attachments from './addTicket/Attachments'

type Tabs = 'current' | 'new' | 'task'

export type FormValues = {
  title: string
  content: string
  name: string
  nip: string
  phone: string
  email: string
  contactName: string
  contactPhone: string
  contactEmail: string
  mailAccount: number
  ticketCategory: number
  ticketSubcategory: number
  tags: Array<string>
  reportedBy: string
  assignTo: Array<number>
  urgent: Boolean
  client: number
  chat: number
  deadline: Date
}

type MaillAccount = {
  id: number
  address: string
}

const AddTicket: React.FC = ({}) => {
  const [tab, setTab] = useState<Tabs>('current')
  const [openModal, setOpenModal] = useState<Boolean>(false)
  const [attachments, setAttachments] = useState<number[]>([])

  const user = window.c.user
  const mailAccounts: MaillAccount[] = window.c.mailAccounts

  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    setValue,
    setError,
    reset,
    clearErrors,
  } = useForm<FormValues>()

  const close = () => {
    reset()
    clearErrors()
    setOpenModal(false)
    setAttachments([])
    setTab('current')
  }

  const onSubmit: SubmitHandler<FormValues> = async data => {
    const res: any = await post(`tickets/add/ticket`, {
      ...data,
      attachments,
      tab,
    })

    if (res.error) {
      res.error.content && setError('content', { message: res.error.content })
      res.error.title && setError('title', { message: res.error.title })
      res.error.nippesel && setError('nip', { message: res.error.nippesel })
      res.error.phone && setError('phone', { message: res.error.phone })
      res.error.name && setError('name', { message: res.error.name })
      res.error.email && setError('email', { message: res.error.email })
      res.error.contact.phone &&
        setError('contactPhone', { message: res.error.contact.phone })
      res.error.contact.name &&
        setError('contactName', { message: res.error.contact.name })
      res.error.contact.email &&
        setError('contactEmail', { message: res.error.contact.email })
    }

    if (res.number) {
      setOpenModal(false)
      reset()
      setAttachments([])
      setTab('current')
    }
  }

  useEffect(() => {
    if (openModal && mailAccounts.length && tab != 'task') {
      setValue('mailAccount', mailAccounts[0].id)
    }
  }, [openModal])

  return (
    <>
      {Object.keys(errors).length > 0 && console.log(errors)}{' '}
      <div>
        <p className="control">
          <button
            className="button is-success is-small"
            type="button"
            onClick={() => {
              clearErrors()
              setOpenModal(true)
            }}
            title={intl.formatMessage({ id: 'ticket / add' })}
          >
            {window.innerWidth > 1200 ? (
              <FormattedMessage id="ticket / add" />
            ) : (
              <span className="icon">
                <i className="fas fa-plus"></i>
              </span>
            )}
          </button>
        </p>
      </div>
      {openModal && (
        <ModalWrapper>
          <form className="modal-card" onSubmit={handleSubmit(onSubmit)}>
            <ModalHeader
              title={intl.formatMessage({
                id: 'ticket / add',
              })}
              onClose={close}
            />
            <ModalBody>
              <div className="tabs is-boxed">
                <ul>
                  <li
                    className={tab == 'current' ? 'is-active' : ''}
                    onClick={() => setTab('current')}
                  >
                    <a>
                      <FormattedMessage id="ticket / add / current client / title" />
                    </a>
                  </li>
                  <li
                    className={tab == 'new' ? 'is-active' : ''}
                    onClick={() => setTab('new')}
                  >
                    <a>
                      <FormattedMessage id="ticket / add / new client / title" />
                    </a>
                  </li>
                  <li
                    className={tab == 'task' ? 'is-active' : ''}
                    onClick={() => setTab('task')}
                  >
                    <a>
                      <FormattedMessage id="ticket / add / task / title" />
                    </a>
                  </li>
                </ul>
              </div>

              {tab == 'current' && (
                <div className="message is-info">
                  <div className="message-body">
                    <SelectClient
                      tab={tab}
                      allowAnonymous={true}
                      control={control}
                      errors={errors}
                    />
                  </div>
                </div>
              )}
              {tab == 'new' && (
                <div className="message is-info">
                  <div className="message-body">
                    <NewClient tab={tab} control={control} />
                  </div>
                </div>
              )}
              <TicketForm
                ticket={null}
                control={control}
                setValue={setValue}
                tab={tab}
              />
              <div className="field">
                <label className="checkbox">
                  <input type="checkbox" {...register('urgent')} />{' '}
                  <FormattedMessage id="ticket / add / urgent" />
                </label>
              </div>
              <Attachments
                attachments={attachments}
                setAttachments={setAttachments}
              />
            </ModalBody>
            <ModalFooterInForm onCancel={close} isSubmitting={isSubmitting} />
          </form>
        </ModalWrapper>
      )}
    </>
  )
}

export default AddTicket
